import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api.js';
import { rule } from '../lib/fieldRules.js';
import { Seo } from '../components/Seo.jsx';
import { Button, Field, Input, Alert } from '../components/ui.jsx';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post('/auth/forgot', { email });
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Seo title="Reset your password" noindex />
      <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-6 py-12">
        <Link to="/" className="text-2xs font-semibold uppercase tracking-widest text-accent">
          Affily
        </Link>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">Reset your password</h1>

        {sent ? (
          <div className="mt-6 space-y-4">
            <Alert tone="positive">
              If <strong>{email}</strong> has an account, a link is on its way. It works once and
              expires in an hour.
            </Alert>
            <p className="text-sm text-ink-muted">
              Nothing arrived? Check spam, then{' '}
              <button type="button" className="font-medium text-accent hover:underline" onClick={() => setSent(false)}>
                try again
              </button>
              . This is also how you set a first password if an agent or Google created your
              account.
            </p>
          </div>
        ) : (
          <>
            <p className="mt-1.5 text-sm text-ink-muted">
              Enter your email and we’ll send a link to choose a new password. If an agent built
              your account, use this to set a password and sign in.
            </p>
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <Alert>{error}</Alert>
              <Field label="Email" required constraint={rule.email()}>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </Field>
              <Button type="submit" size="lg" className="w-full" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          </>
        )}

        <p className="mt-6 text-center text-sm text-ink-muted">
          <Link to="/login" className="font-medium text-accent hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </>
  );
}
